// src/utils/showDataCache.js
const CACHE_KEY = 'pointsToolShowData';
const TTL_MINUTES = 5;

/**
 * Save show data to localStorage with timestamp
 * @param {Object} data - {year, state, breed}
 */
export const saveShowData = (data) => {
  const cacheData = {
    ...data,
    timestamp: Date.now(),
    expiresAt: Date.now() + (TTL_MINUTES * 60 * 1000)
  };

  try {
    localStorage.setItem(CACHE_KEY, JSON.stringify(cacheData));
  } catch (error) {
    console.error('Failed to save show data to cache:', error);
  }
};

/**
 * Load show data from localStorage, checking expiration
 * @returns {Object|null} - {year, state, breed} or null if expired/missing
 */
export const loadShowData = () => {
  try {
    const cached = localStorage.getItem(CACHE_KEY);
    if (!cached) return null;

    const data = JSON.parse(cached);

    // Check if expired
    if (Date.now() > data.expiresAt) {
      clearShowData();
      return null;
    }

    return {
      year: data.year,
      state: data.state,
      breed: data.breed
    };
  } catch (error) {
    console.error('Failed to load show data from cache:', error);
    clearShowData();
    return null;
  }
};

/**
 * Clear cached show data
 */
export const clearShowData = () => {
  try {
    localStorage.removeItem(CACHE_KEY);
  } catch (error) {
    console.error('Failed to clear show data cache:', error);
  }
};